module.exports = __webpack_public_path__ + "static/media/logo-natural-stone.8b95fadd.svg";